import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { Selection } from '../../interfaces/selection';
import { CardMenuItem, SelectionCardMenuComponent } from '../selection-card-menu/selection-card-menu.component';

@Component({
  selector: 'outlaw-selection-card',
  templateUrl: './selection-card.component.html',
  styleUrls: ['./selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectionCardMenuComponent],
})
export class SelectionCardComponent {
  selection = input.required<Selection>();
  menuItems = input<CardMenuItem[]>([
    { label: 'Edit', action: 'edit' },
    { label: 'Delete', action: 'delete' },
  ]);
  cardClicked = output<Selection>();
  menuAction = output<{ action: string; selection: Selection }>();
  menuOpen = signal(false);

  onClick(): void {
    this.cardClicked.emit(this.selection());
  }

  onMenuAction(action: string): void {
    this.menuAction.emit({ action, selection: this.selection() });
  }
}
